import { render } from "./DashboardErrors.vue?vue&type=template&id=c84a0b08&scoped=true"
import script from "./DashboardErrors.vue?vue&type=script&lang=js"
export * from "./DashboardErrors.vue?vue&type=script&lang=js"

import "./DashboardErrors.vue?vue&type=style&index=0&id=c84a0b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84a0b08"]])

export default __exports__